import React from 'react';
import moment from 'moment';

import { Icon } from '@blueprintjs/core';

import TaskModel from '../../models/Task';
import { Priority } from '../../models/Priority';

import './TaskItem.scss';

interface ITaskItemProps {
    task?: TaskModel;
}

const TaskItem: React.StatelessComponent<ITaskItemProps> = (props) => {
    if (!props.task) {
        return (
            <div className="lh-task-item" style={{ borderBottom: '1px solid #ccc' }}>
                <div style={{ padding: '8px' }}>
                    <div className="bp3-skeleton" />
                </div>
            </div>
        );
    }

    let icon: JSX.Element = <></>;

    switch (props.task.priority) {
        case Priority.High:
            icon = <Icon icon="issue" style={{ color: 'red' }} />;
            break;
        case Priority.Normal:
            icon = <Icon icon="wrench" style={{ color: '#565656' }} />;
            break;
        case Priority.Low:
            icon = <Icon icon="circle-arrow-down" style={{ color: '#cccc00' }} />;
            break;
        default:
            icon = <Icon icon="blank" />;
            break;
    }

    return (
        <div className="lh-task-item">
            <div className="line-1">
                {icon} {props.task.name} <span className="due-date">(DUE: {moment(props.task.dueDate).format('l')})</span>
            </div>
            <div className="line-2">{props.task.description}</div>
        </div>
    );
};

export default TaskItem;



// WEBPACK FOOTER //
// ./src/components/common/TaskItem.tsx